<template>
  <div class="trainings-page">

    <!-- aboutus intro -->
    <section class="consultations trainings-page-hero" :class="{ 'trainings-hero--en': !isAr }">
      <b-container fluid class="px-0">
        <b-row
          no-gutters
          class="trainings-hero-split intro-section align-items-stretch mx-0"
          :class="{ 'flex-xl-row-reverse': isAr }"
        >
          <b-col
            cols="12"
            xl="6"
            class="trainings-hero-copy d-flex align-items-center py-5 px-4 px-xl-5"
          >
            <div class="trainings-hero-text w-100">
              <h1 class="mb-3"><b>{{ langDec.trainings_hero_title }}</b></h1>
              <p class="mb-0">{{ langDec.trainings_hero_subtitle }}</p>
            </div>
          </b-col>
          <b-col cols="12" xl="6" class="trainings-hero-art p-0" aria-hidden="true" />
        </b-row>
      </b-container>
    </section>


    <section class="greyBox">
      <b-container fluid>
        <b-row class="">
          <b-col xl="12" lg="12" md="12" class="trainings-copy-col">
            <div class="text-section">
              <div>
                <div class="title">
                  <h2 class="name">
                    {{ langDec.trainings_section_title }}
                  </h2>
                  <span><b>{{ langDec.trainings_what_about }}</b></span>
                </div>
                <p class="trainings-body-p">
                  {{ langDec.trainings_about_body }}
                </p>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <section class="greyBox">
      <b-container fluid>
        <b-row class="">
          <b-col xl="12" lg="12" md="12" style="text-align: center;">
            <div class="">
              <div>
                <div class="title">
                  <h2 class="name">
                    {{ langDec.trainings_goals_title }}
                  </h2>

                  <br>
                </div>
                <b-row class="trainings-goals-row">
                  <b-col xl="4" lg="12" md="12" class="trainings-goal-col">
                    <div class="trainings-goal-box">
                      <div>
                        <p>
                          {{ langDec.trainings_goal_1 }}
                        </p>
                      </div>
                    </div>
                  </b-col>
                  <b-col xl="4" lg="12" md="12" class="trainings-goal-col">
                    <div class="trainings-goal-box">
                      <div>
                        <p>
                          {{ langDec.trainings_goal_2 }}
                        </p>
                      </div>
                    </div>
                  </b-col>
                  <b-col xl="4" lg="12" md="12" class="trainings-goal-col">
                    <div class="trainings-goal-box">
                      <div>
                        <p>
                          {{ langDec.trainings_goal_3 }}
                        </p>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>


    <section class="greyBox">
      <b-container fluid>
        <b-row class="">
          <b-col xl="12" lg="12" md="12" style="text-align: center;">
            <div class="">
              <div>
                <div class="title">
                  <h2 class="name">
                    {{ langDec.trainings_courses_title }}
                  </h2>

                  <br>
                </div>
                <b-row class="">
                  <b-col xl="3" lg="12" md="12" class="mb-5" v-for="item in items" :key="item.id">
                    <div class="transBox shadow-sm p-2 px-4">
                      <div class="transBox-icon">
                        <img class="gridSection-img" width="150px" height="150px" :src="'https://api.takhatty.com/' + item.imageUrl" alt="logo" />
                      </div>
                      <div class="trainings-card-text text-start">
                        <div>
                          <h5 class="mt-2">
                            {{ item.title }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>


    <!-- subscribe -->
    <section class="subscribe">
      <div>
        <div>
          <div class="">
            <div class="col-md-12 col-sm-12 col-xs-12 trainings-subscribe-outer">
              <div class="py-5 my-5">
                <div class="">
                  <h2>{{ langDec.trainings_subscribe_heading }}</h2>
                  <div class="description">
                    <br>
                    <p v-if="!googleplay && !applestore" style="color: red;">
                      <b>{{ langDec.articles_app_unavailable }}</b>
                      <br>
                      <b-button @click="goToRoute('contactus')" class="px-4 py-2 my-4" variant="primary">
                        <span>{{ langDec.articles_contact_us }}</span>
                      </b-button>
                    </p>
                  </div>
                  <div v-if="googleplay || applestore" class="action-btns mt-2">
                    <b-button v-if="applestore" @click="goTowebsite(applestore)" class="px-4 py-3 mx-4 my-3"
                      style="background-color: black;color:white !important;border: black !important;">
                      <div
                        class="store-badge-inner carousel-btn-in-div px-3"
                        :class="{ 'store-badge-inner--en': !isAr }"
                      >
                        <div class="store-badge-inner__icon store-badge-inner__icon--apple">
                          <img class="store-badge-inner__apple-img"
                            src="../assets/images/Apple_logo_white.svg.png" alt="">
                        </div>
                        <div class="carousel-btn-in-div-text store-badge-inner__text trainings-subscribe-store-text">
                          <span>{{ langDec.nav_available_on }}</span>
                          <br>
                          <span>App Store</span>
                        </div>
                      </div>
                    </b-button>
                    <b-button v-if="googleplay" @click="goTowebsite(googleplay)" class="px-4 py-3 mx-4 my-3"
                      variant="primary" style="color:white !important;border: black !important;">
                      <div
                        class="store-badge-inner px-3"
                        :class="{ 'store-badge-inner--en': !isAr }"
                      >
                        <div class="store-badge-inner__icon store-badge-inner__icon--google">
                          <svg class="kOqhQd" aria-hidden="true" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
                            <path fill="none" d="M0,0h40v40H0V0z"></path>
                            <g>
                              <path
                                d="M19.7,19.2L4.3,35.3c0,0,0,0,0,0c0.5,1.7,2.1,3,4,3c0.8,0,1.5-0.2,2.1-0.6l0,0l17.4-9.9L19.7,19.2z"
                                fill="#EA4335"></path>
                              <path
                                d="M35.3,16.4L35.3,16.4l-7.5-4.3l-8.4,7.4l8.5,8.3l7.5-4.2c1.3-0.7,2.2-2.1,2.2-3.6C37.5,18.5,36.6,17.1,35.3,16.4z"
                                fill="#FBBC04"></path>
                              <path d="M4.3,4.7C4.2,5,4.2,5.4,4.2,5.8v28.5c0,0.4,0,0.7,0.1,1.1l16-15.7L4.3,4.7z"
                                fill="#4285F4"></path>
                              <path
                                d="M19.8,20l8-7.9L10.5,2.3C9.9,1.9,9.1,1.7,8.3,1.7c-1.9,0-3.6,1.3-4,3c0,0,0,0,0,0L19.8,20z"
                                fill="#34A853"></path>
                            </g>
                          </svg>
                        </div>
                        <div class="carousel-btn-in-div-text store-badge-inner__text trainings-subscribe-store-text">
                          <span>{{ langDec.nav_available_on }}</span>
                          <br>
                          <span>Google Play</span>
                        </div>
                      </div>
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>


<script>
import { mapGetters } from "vuex"
import expertCarousel from "../components/ExpertCarousel.vue"
import { sendRequest } from '../utils/RequestHelper.js'

export default {
  name: 'Home',
  data() {
    return {
      googleplay: process.env.VUE_APP_GOOGLEPLAYLINK,
      applestore: process.env.VUE_APP_APPLESTORELINK,
      items: [],
      pageIsLoading: false,
    }
  },

  components: {
    expertCarousel
  },

  computed: {
    ...mapGetters(["getLangData", "getlang"]),
    langDec() {
      return this.getLangData || {}
    },
    isAr() {
      return this.getlang === "ar"
    },
  },
  methods: {
    goTowebsite(link) {
      window.open(link, "_blank");
    },
    goToContactus(name) {
      this.$router.push({
        name
      })
    },
    goToRoute(name, id) {
      this.$router.push({
        name,
        id
      });
    },
     loadData() {
      this.pageIsLoading = true;
      let body = {
        pageNumber: 1,
        pageSize: 999999
      }
      this.pageIsLoading = true;
      sendRequest('post', 'CourseAndEnrichment/CourseSearch',true , body,
        (response) => {
          this.items = response.data.data.items;
          this.pageIsLoading = false;
        },
        () => {
          this.pageIsLoading = false;
          this.alertType = 'danger';
          this.alertText = this.langDec.errorMessage || 'Error loading data';
        }
      );
    }
  },
  created() {
    this.loadData();
  }
}
</script>

<style scoped>
.trainings-page-hero .trainings-hero-split {
  min-height: 450px;
}

.trainings-hero-art {
  min-height: 280px;
  background-color: #0d7a45;
  background-image: url(../assets/images/consultationsGreenBG.png);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: left center;
}

.trainings-page-hero:not(.trainings-hero--en) .trainings-hero-art {
  background-size: contain;
  background-position: center center;
}

.trainings-hero-copy {
  background: linear-gradient(160deg, #054d2a 0%, #006633 42%, #0a7a44 100%);
  color: #fff;
}

.trainings-hero-text {
  text-align: start;
}

.trainings-hero-text h1 {
  font-size: 2.25rem !important;
  font-weight: bolder !important;
  line-height: 1.2;
  color: #fff !important;
}

.trainings-hero-text p {
  font-size: 1.125rem;
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.96) !important;
}

@media (min-width: 1200px) {
  .trainings-hero-art {
    min-height: 450px;
  }

  .trainings-hero-text h1 {
    font-size: 2.5rem !important;
  }

  .trainings-hero-text p {
    font-size: 1.2rem;
  }
}

@media (max-width: 991.98px) {
  .trainings-page-hero .trainings-hero-split {
    min-height: 0;
  }

  .trainings-hero-art {
    min-height: 260px;
  }
}

@media (max-width: 767.98px) {
  .trainings-hero-art {
    min-height: 220px;
  }

  .trainings-hero-text h1 {
    font-size: 1.75rem !important;
  }
}

.trainings-copy-col .text-section,
.trainings-body-p {
  text-align: start;
}

.trainings-goals-row {
  font-size: 21px;
  font-weight: bold;
  color: #006633;
}

.trainings-goal-col {
  text-align: start;
}

.trainings-goal-box {
  background-color: #f6fbf2;
  padding: 30px;
  min-height: 120px;
  border-radius: 8px;
}

.trainings-card-text {
  text-align: start;
}

.trainings-subscribe-outer {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.store-badge-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  direction: ltr;
  gap: 0.875rem;
}

.store-badge-inner--en {
  flex-direction: row-reverse;
}

.store-badge-inner__icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.store-badge-inner__icon--apple {
  width: 35px;
  height: 35px;
  color: #fff;
}

.store-badge-inner__icon--google {
  width: 40px;
  height: 40px;
}

.store-badge-inner__apple-img {
  width: 35px;
  height: auto;
  margin-top: -3px;
  display: block;
}

.trainings-subscribe-store-text {
  font-size: 14px;
  line-height: 1.25;
  text-align: start;
}


/* greyBox */
.greyBox {
  padding: 50px 40px;
}

.greyBox .text-section {
  background-color: #f5f5f5;
  border-radius: 10px;
  padding: 20px 30px;
  font-size: 20px;
  width: 100%;
  text-align: start;
}

.greyBox .text-section .title-green {
  color: #006633;
  font-size: 24px;
}

.greyBox .text-section .name {
  font-size: 32px;
  margin-top: 20px;
  margin-bottom: 30px;
  font-weight: bold;
}

.greyBox .text-section .pref {
  font-size: 16px;
  color: #858585;
}


/* subscribe */
.subscribe {
  background-color: #f5f5f5;
}


/* section93 */
.section93 {
  padding: 40px 40px;
}

.section93 .itemBox {
  border: 1px solid #36A9E1;
  padding: 15px;
  border-radius: 10px;
  margin-top: 30px;
  margin-bottom: 30px;
}

@media (max-width: 991.98px) {

  .greyBox,
  .section93 {
    padding: 50px 30px;
  }

  .text-section h2 {
    font-size: 30px !important;
    font-weight: bolder !important;
  }

  .button-section .btn {
    font-size: 10px !important;
  }

  .greyBox .text-section {
    padding: 10px;
  }
}

@media (max-width: 767.98px) {

  .greyBox,
  .section93 {
    padding: 40px 10px;
  }
}
</style>